import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { AppointmentFormService } from '../appointment-form.service';
import { ServiceAppointmentState } from '../../../store/service-appointment/service-appointment.reducer';
import { Store } from '@ngrx/store';
import * as fromSelectors from '../../../store/service-appointment/service-appointment.selectors';
import { Observable } from 'rxjs';
import { AppointmentType, IAvailability, IAvailabilityOptions } from '@signal/asp-data-commons';
import { LoadAvailability } from '../../../store/service-appointment/service-appointment.actions';
import { take } from 'rxjs/operators';
import { DateTime } from 'luxon';
import { TranslateService } from '@ngx-translate/core';
import { SubscriptionList } from '../../../shared/models/asp.types';
import { unsubscribeSubscriptions } from '../../../shared/services/util.service';

@Component({
  selector: 'app-appointment-time',
  templateUrl: './appointment-time.component.html',
  styleUrls: ['./appointment-time.component.scss']
})
export class AppointmentTimeComponent implements OnInit, OnDestroy {
  @Input() stepIndex = 2;
  @Input() transport;
  @Input() vin: string;
  @Input() appointmentId: string;
  step: UntypedFormGroup;
  private availability: UntypedFormControl;
  availabilityOptions$: Observable<IAvailabilityOptions>;
  availabilityOptionsLoading$: Observable<boolean>;
  availability$: Observable<IAvailability>;
  availabilityLoading$: Observable<boolean>;
  subs: SubscriptionList = {};
  languageId='';
  isEditMode=false;
  apptType = AppointmentType.SERVICE;
  apptAdvisor = '';

  constructor(
    private readonly formBuilder: UntypedFormBuilder,
    private readonly serviceAppointmentState: Store<ServiceAppointmentState>,
    private readonly translate: TranslateService) {
  }

  ngOnInit(): void {
    this.ready();
  }

  ready() {
    this.step = this.formBuilder.group({
      availability: this.availability,
      timeSlotValidator: [false, Validators.required]
    });

    this.availabilityOptions$ = this.serviceAppointmentState.select(fromSelectors.selectAvailabilityOptionsData);
    this.availabilityOptionsLoading$ = this.serviceAppointmentState.select(fromSelectors.selectAvailabilityOptionsLoading);
    this.availability$ = this.serviceAppointmentState.select(fromSelectors.selectAvailabilityData);
    this.availabilityLoading$ = this.serviceAppointmentState.select(fromSelectors.selectAvailabilityLoading);
    this.subs.form = this.serviceAppointmentState.select(fromSelectors.selectAppointmentForm).subscribe((data:any) => {
      this.languageId=data?.availabilityForm?.availability?.languageId;
      this.isEditMode=data?.isEditMode;
      this.apptAdvisor = data?.availabilityForm?.availability?.advisorId;
    });
  }

  onMonthChange($event: DateTime) {
    this.subs.advisorId = this.serviceAppointmentState.select(fromSelectors.selectAvailabilityFormAdvisorId)
      .pipe(take(1))
      .subscribe((advisorId: string) => {
        const date = $event.toFormat('yyyy-MM-dd');
        this.serviceAppointmentState.dispatch(new LoadAvailability({ date, advisorId, transport: this.transport, 
          vin: this.vin, appointmentId: this.appointmentId }));
      });
  }
  setValidatorsForTimeSlot(event) {
    if (event) {
      this.step.controls.timeSlotValidator.setErrors({ error: this.translate.instant('service.invalidTimeslot') });
      this.step.controls.timeSlotValidator.setValidators(Validators.required);
    } else {
      this.step.controls.timeSlotValidator.clearValidators();
      this.step.controls.timeSlotValidator.updateValueAndValidity();
    }
  }

  ngOnDestroy(): void {
    unsubscribeSubscriptions(this.subs);
  }
}
